module.exports = __webpack_public_path__ + "static/media/Extruded tooth12.cd4eaab5.png";